import { environment } from '@wo-environments';

export class AuthContext {
  private static readonly ISS_DOMAINS = [
    'issworld.com',
    'issfirst.com',
  ];
  private static readonly AUTH_EMAIL_KEY = 'AUTH_EMAIL_KEY';
  private static readonly IMPERSONATE_ID_HEADER = 'X-WO-Impersonate-Id';

  static getEmail(): string {
    return localStorage.getItem(this.AUTH_EMAIL_KEY) || '';
  }

  static getImpersonatedEmail(): string | null {
    return localStorage.getItem(this.IMPERSONATE_ID_HEADER);
  }

  static setEmail(email: string): void {
    localStorage.setItem(this.AUTH_EMAIL_KEY, email.toLowerCase().trim());
  }

  public static setImpersonatedEmail(email: string): void {
    localStorage.setItem(this.IMPERSONATE_ID_HEADER, email.toLowerCase().trim());
  }

  public static clearImpersonatedEmail(): void {
    localStorage.removeItem(this.IMPERSONATE_ID_HEADER);
  }

  static isInternalUser(): boolean {
    return this.hasEmail() && this.isISSEmail(this.getEmail());
  }

  static isExternalUser(): boolean {
    return this.hasEmail() && !this.isInternalUser();
  }

  static hasEmail(): boolean {
    return Boolean(this.getEmail());
  }

  static inferEmail(email: string | undefined): string {
    return email || this.getEmail();
  }

  static inferUsername(firstName: string | undefined, lastName: string | undefined, username: string | undefined): string {
    return [ lastName, firstName ].filter(Boolean).join(', ') || username || 'Guest';
  }

  private static isISSEmail(email: string): boolean {
    return this.ISS_DOMAINS.some(domain => email.endsWith(domain));
  }
}

export const HostUriFactory = () => {
  if (window.ISS_ENV_MOBILE && environment.mobileScheme) {
    return `${ environment.mobileScheme }://${ window.location.hostname }`;
  }
  return AuthContext.isInternalUser() ? '' : window.location.origin;
};
